import { useEffect } from 'react';

interface ShortcutHandlers {
  onSearch?: () => void;
  onSettings?: () => void;
  onEscape?: () => void;
}

export function useKeyboardShortcuts({
  onSearch,
  onSettings,
  onEscape,
}: ShortcutHandlers) {
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      const meta = e.metaKey || e.ctrlKey;
      const target = e.target as HTMLElement;
      const isInput =
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable;

      if (e.key === 'Escape' && onEscape) {
        onEscape();
        return;
      }

      if (isInput) return;

      if (meta && e.key === 'k' && onSearch) {
        e.preventDefault();
        onSearch();
      }

      if (meta && e.key === ',' && onSettings) {
        e.preventDefault();
        onSettings();
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onSearch, onSettings, onEscape]);
}
